/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonGroup, Callout, Drawer, DrawerSize, Icon, Intent, Popover, Position, TabId, Toaster } from "@blueprintjs/core"
import { Fragment, useMemo, useState } from "react"
import { showToast } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { schema as _schema } from "../../../data/schema" 
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import FieldChanger from "./FieldChanger"
import updateHistory from "./utils/updateHistory"

/* Protopia Ecosystem component */
export interface ISectionEditDrawerProps {
   
}
const SectionEditDrawer = (props: ISectionEditDrawerProps): JSX.Element => {
    const {isSectionEdit, readyToClose } = useLandingStore( (state:ILandingStore) => state )
    const onClose = () => {
        if( readyToClose) {
            useLandingStore.setState({ 
                isSectionEdit: false, 
                currentEditData: {}, 
                sectionEditMeatID: "" 
            }) 
        }
        else {
            const toaster: Promise<Toaster> = showToast({
                //intent:Intent.DANGER,
                message: <div>
                    <div className="mb-2 lead ">{__("You must update change before closing")}</div>
                    <div className="d-flex">
                        <Button intent={Intent.DANGER} className="mr-2" onClick={ () => {
                            onCancel( toaster ) 
                        }}>
                            {__("Close allways")}
                        </Button>
                        <Button intent={Intent.SUCCESS} onClick={() => {
                            updateAndClose( toaster ) 
                        }} >
                            {__("Update and close")}
                        </Button>
                    </div>
                </div> 
            })
        }
    } 
    const onCancel = (toaster: Promise<Toaster> ) => {
        useLandingStore.setState({ readyToClose: true, isSectionEdit: false, currentEditData: {} }) 
        toaster?.then((res) => res.clear())
    }
    return <Drawer
        position={ Position.LEFT }
        className="section-edit-drawer"
        portalClassName="z-index-110-none"
        isOpen={ isSectionEdit }
        size={ DrawerSize.LARGE }
        onClose={onClose}
    >
       <EditorContent />
       {/* Кнопка "Закрыть панель" */}
       <Button size="large" className="btn-stretch btn-close-drawer " onClick={onClose}> 
            <Icon icon="cross" color="#FFFFFF" size={25} /> 
       </Button>
    </Drawer>
}
export default SectionEditDrawer

export interface IEditorContentProps extends ISectionEditDrawerProps {
     
}
const EditorContent = (props: IEditorContentProps): JSX.Element => {
    const { schema, sectionEditTab, currentEditData, readyToClose, }   = useLandingStore( (state:ILandingStore) => state ) 
    const [ selectedTabId, setSelectedTabId ] = useState<TabId>( sectionEditTab || "main" )  
    const setIsSectionEditOpen = ( ) => {
        useLandingStore.setState({ isSectionEdit: false, needUpdate: true })
    }
    const onChange = ( _value: any, _field: string, data: any, field: string ) => {  
        console.log(_value, _field, field) 
        const newData = { 
            currentEditData: {
                ...currentEditData,
                [ _field || field ] : _value
            },
            readyToClose: false,
        }
        console.log( newData )        
        useLandingStore.setState( newData )      
    } 
    
    const dataSchema = useMemo(() => _schema()[ schema ], [schema]) 
    const tab = useMemo(() => dataSchema.tabs.find((tab: any) => tab._id === selectedTabId), [selectedTabId]) 

    if(!dataSchema) {
        return <CalloutNoExists />
    } 

    return <div className="w-100 h-100 d-flex flex-column">
        <div style={{backgroundColor: "var(--force-contrast-secondary-opacity-color)"}} className="pt-1">
            <ButtonGroup className="w-100">
                {
                    /* кнопки сверху*/
                    _schema()[ schema ] && (_schema()[ schema ].tabs || [])
                    .filter((tab: any) => !tab.latent)
                    .map((tab: any) => {
                        const is = tab._id.toString() === selectedTabId.toString()
                        return <Button
                            key={tab._id} 
                            variant={ is ? "solid" : "minimal"}
                            className={ is ? "border-bottom-0 shadow-none" : " "}
                            intent={ Intent.NONE }
                            onClick={ () => setSelectedTabId(tab._id) }
                        >   
                            <div className="small pt-4">{__(tab.title) }</div>
                        </Button>  
                    })
                }
                <div className="flex-grow-100"></div>
                {
                    /* поповер с дополнительными кнопками сверху */
                    !!_schema()[ schema ] && _schema()[ schema ].tabs
                    .filter((tab: any) => !!tab.latent).length &&
                    <Popover
                        position={Position.BOTTOM_RIGHT}
                        portalClassName="z-index-120" 
                        content={
                            <ButtonGroup vertical>
                                {
                                    _schema()[ schema ] && _schema()[ schema ].tabs
                                        .filter((tab: any) => !!tab.latent)
                                        .map((tab: any) => {
                                            const is = tab._id.toString() === selectedTabId.toString()
                                            return <Button
                                                key={tab._id}
                                                alignText="left" 
                                                variant={ is ? "solid" : "minimal"} 
                                                intent={ Intent.NONE }
                                                onClick={ () => setSelectedTabId(tab._id) }
                                            >   
                                                <div className="small">{__(tab.title) }</div>
                                            </Button> 
                                        })
                                }
                            </ButtonGroup> 
                        }
                    >
                        <Button 
                            variant={ "minimal"}
                            className={ "border-bottom-0 shadow-none ml-auto" }
                            intent={ Intent.NONE }  
                            style={{maxWidth: 20}}
                        >    
                            <div className="small pt-4"><i className="fas fa-ellipsis-v"></i></div>
                        </Button>  
                    </Popover>
                }
            </ButtonGroup>
        </div>
        {/* Depricate: Верхняя панель редактирования. */}
        {/* <div className="pt-4">
            {
                Object.keys( dataSchema.apollo_fields)
                .filter(field => dataSchema && 
                    dataSchema.apollo_fields[ field ].tab === "top" && 
                    !dataSchema.apollo_fields[ field ].isHidden 
                )
                .map((field: any) => { 
                    return <Fragment key={ field }>
                        <FieldChanger 
                            {...dataSchema.apollo_fields[ field ]}
                            value={ currentEditData[field] }
                            notClear
                        /> 
                    </Fragment>
                })
            }  
        </div> */}
        <div className="flex-grow-100 overflow-y-auto pr-0 py-4 ">
            {
                /* Комментарий-описание вкладки */
                tab?.description &&
                    <Callout intent={Intent.SUCCESS} className="width-auto">
                        <div className="small letter-spacing1 p-2 ">
                            { __( tab?.description ) }
                        </div>
                    </Callout>
            }
            { 
                /* Основные панели редактирования */
                Object.keys( dataSchema.apollo_fields )
                    .filter(field => dataSchema && 
                        dataSchema.apollo_fields[ field ].tab === selectedTabId && 
                        !dataSchema.apollo_fields[ field ].isHidden 
                    )
                    .map((field: any) => { 
                        return <Fragment key={ field }> 
                            <FieldChanger 
                                {...dataSchema.apollo_fields[ field ]}
                                dataName={ field }
                                dataSection={ /*schema*/ "data" }
                                field={ field }
                                value={ currentEditData[field] }
                                origin={currentEditData}
                                onChange={ ( value: any, _field: string, data: any ) => onChange(value, _field, data, field) }
                                notClear
                            />
                        </Fragment>
                    })
            }
        </div> 
        <ButtonGroup fill size="large">
            <Button 
                intent={ Intent.DANGER }
                disabled={ !readyToClose } 
                fill 
                onClick={setIsSectionEditOpen}
            >
                {__("Close")}
            </Button>
            <Button intent={Intent.SUCCESS} fill onClick={ () => updateAndClose() }>
                {__("Update and close")}
            </Button>
        </ButtonGroup>
    </div>
}


const updateAndClose = ( toaster: Promise<Toaster>| null = null) => { 
    const currentLanding =  useLandingStore.getState().currentLanding
    const schema =  useLandingStore.getState().schema
    const currentEditData =  useLandingStore.getState().currentEditData
    let cr: ILanding = currentLanding, 
        step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "",

    } 
    switch( schema ) {
        case "Section" :
            cr = {
                ...currentLanding,
                sections: [
                    ...currentLanding.sections.map((s: ILandingSection) => { 
                        if(s.id === currentEditData.id){
                            step.prevData   = s
                            step.data       = currentEditData
                            step.title      = "Section edit"
                            return currentEditData
                        }
                        return s
                    })
                ]
            } 
            break
        case "Landing":
            step.prevData   = currentLanding
            step.data       = currentEditData
            step.type       = HISTORY_TYPE.SETTINGS
            step.title      = "Landing settings edit"
            cr = { ...currentLanding, ...currentEditData }
            break
    }
    //console.log( schema, cr )
    
    useLandingStore.setState({  
        readyToClose: true, 
        isSectionEdit: false, 
        currentEditData: {}, 
    }) 
    setTimeout(() => updateHistory( step, cr ), 10)
    toaster?.then( (res) => res.clear() ) 
}